export const routeConstants = {
  home: '',
  login: 'login',
  notFound: '404',
  clients: 'clients',
  clientDetails: 'client-details',
  booking: 'booking',
} as const;

export const routeParams = {
  clientId: 'cid',
  date: 'date',
  bookingType: 'bookingType',
} as const;

export const routeQueryParams = {
  scheduledId: 'scheduledId',
} as const;

export const routeParamValues = {
  newBooking: 'new',
  historyBooking: 'history',
};

export const queryParams = {
  date: 'date',
} as const;
